/**
 * Whether the eye rides the stride.
 *
 * Off is off at the amplitude rather than over the finished frame: the number reaches
 * `firstPersonView` through `ViewPreference`, where both sines are multiplied by it, so there is no
 * residual sway at any speed and the viewmodel is not left bobbing against a camera that has
 * stopped. See [viewMotion](../../../core/motion/viewMotion.ts) for the seam.
 *
 * One of the three under the master. On by default, and irrelevant while the master is down.
 */

import { DEFAULT_MOTION_EFFECT, setMotionEffect } from '@/core/motion/motionPreference';
import { SETTING_HEAD_BOB_HINT, SETTING_HEAD_BOB_LABEL } from '@/text/settingsText';
import { toggleApply, toggleValue } from '@/ui/settings/controls/toggleSwitch';
import type { SettingDefinition } from '@/ui/settings/settingContract';

export const HEAD_BOB: SettingDefinition = {
  id: 'headBob',
  section: 'accessibility',
  label: SETTING_HEAD_BOB_LABEL,
  hint: SETTING_HEAD_BOB_HINT,
  control: { kind: 'toggle' },
  defaultValue: toggleValue(DEFAULT_MOTION_EFFECT),
  apply: toggleApply((on: boolean): void => {
    setMotionEffect('headBob', on);
  }),
};
